import { KundserviceAppApiClient } from "./KundserviceAppApiClient";
import { useAuthStore } from "@/stores/authStore";

export function useApi(): KundserviceAppApiClient {
  return new KundserviceAppApiClient(
    {
      getAuthorization: async () => {
        const token = await useAuthStore().getAuthToken();
        return `Bearer ${token}`
      },
    },
    import.meta.env.VITE_API_URL,
  );
}
